<template>
  <v-sheet
    v-if="items"
    class="trademarks pb-16 pt-10 mt-0 pt-sm-16 mt-sm-4 mb-11"
    color="transparent"
  >
    <LoadingWidget v-if="loading" />
    <v-container class="py-0" v-else>
      <TitleWidget>Marcas Registradas</TitleWidget>
      <div
        v-if="items.length"
        class="
          d-flex
          justify-sm-space-around justify-center
          flex-wrap
          items-group
          pt-16
          pb-8
        "
      >
        <div v-for="({ title, img, link }, i) in itemsSliced" :key="i">
          <img v-if="!link" class="item-img" :src="files + img" :alt="title" />
          <a v-else target="_blank" :href="link">
            <img class="item-img d-block" :src="files + img" :alt="title" />
          </a>
        </div>
      </div>
      <div class="d-flex justify-center">
        <v-btn
          v-if="items.length > maxItemsIndex"
          height="52px"
          width="166px"
          class="
            text-none
            grey--text
            text--lighten-1
            rounded-0
            elevation-0
            text-h6
            font-weight-bold
          "
          color="primary"
          to="/marcas"
        >
          Ver mais
        </v-btn>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
const _config = {
  mod: "trademarks",
};
export default {
  components: { LoadingWidget, TitleWidget },
  data: () => ({
    maxItemsIndex: 20,
    loading: true,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    itemsSliced() {
      return this.items.slice(0, this.maxItemsIndex);
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then((this.loading = false));
  },
};
</script>

<style lang="scss" scoped>
.trademarks {
  .items-group {
    gap: 27px 120px;
    @media (max-width: 600px) {
      gap: 50px;
    }
    @media (max-width: 500px) {
      gap: 30px;
    }
    @media (max-width: 400px) {
      justify-content: space-around !important;
      gap: 10px;
    }
  }
  .item-img {
    filter: grayscale(1);
    height: 100px;
    object-fit: contain;
    aspect-ratio: 1/1;
    transition: all 0.15s;
    &:hover {
      filter: grayscale(0);
    }
  }
}
</style>
